import './public-path';
import 'intersection-observer';
import 'matchmedia-polyfill';
import 'matchmedia-polyfill/matchMedia.addListener';
import './lib/media-check';

import route from './router';
import OnePerformance from '@/modules/module-onePerformance';

import '../styles/style.scss';
import '@/components/index';
import ShopifyAPI from '@/gateway/ShopifyAPI';

const settings = JSON.parse(window.localStorage.getItem('fob-settings'));

/*
	Extending ORW object
*/
ORW.utilities.mediaCheck = function (entryCallback, exitCallback) {
  if (!entryCallback) {
    entryCallback = function () {};
  }
  if (!exitCallback) {
    exitCallback = function () {};
  }
  mediaCheck({
    media: ORW.breakpoint,
    entry: entryCallback,
    exit: exitCallback
  });
};

/*
	Global Function Calls
*/
ORW.utilities.mediaCheck(
  function () {
    console.log('large screen');
    ORW.responsive = 'large';
  },
  function () {
    console.log('small screen');
    ORW.responsive = 'small';
  }
);

/*
    1R Performance Injections
*/
if (ORW.performance.webVitalsEnable) {
  OnePerformance.init();
}

/*
	Recharge initialization
*/
recharge.init({
  storeIdentifier: settings?.shop_permanent_domain,
  storefrontAccessToken: process.env.API_RECHARGE_STOREFRONT_ACCESS_TOKEN,
  loginRetryFn: () => {
    return recharge.auth.loginShopifyAppProxy().then((session) => {
      recharge.customerSession = session;

      return session;
    });
  }
});

ShopifyAPI.setCartCreatedTime();

route();
